import trimValue from "./trimvalue";

export default {
    mounted() {
        this.addBlurEventListeners();
    },
    beforeDestroy() {
        this.removeBlurEventListeners();
    },
    watch: {
        showDetailedSearch(newVal, oldVal) {
            this.$nextTick(() => {
                this.addBlurEventListeners();
            });
        }
    },
    methods: {
        addBlurEventListeners() {
            if (this.$el && this.$el.querySelectorAll) {
                const elements = this.$el.querySelectorAll('input, textarea');
                elements.forEach(el => {
                    el.removeEventListener('blur', this.handleBlur); // Remove existing listener to prevent duplicates
                    el.addEventListener('blur', this.handleBlur);
                });
            }
        },
        removeBlurEventListeners() {
            if (this.$el && this.$el.querySelectorAll) {
                const elements = this.$el.querySelectorAll('input, textarea');
                elements.forEach(el => {
                    el.removeEventListener('blur', this.handleBlur);
                });
            }
        },
        handleBlur(event) {
            if (event && event.target) {
                trimValue(event.target);
            }
        }
    }
};
